import { get } from 'lodash';
export { disclaimerErrorMap } from './map';
export { DateSchema, EmailSchema, UrlSchema, E164PhoneSchema } from './validators';

export class ValidationError extends Error {
  fieldErrors: IFieldErrors = {};
  constructor(errors: IFieldErrors) {
    super(`Data failed to pass validations`);
    this.fieldErrors = errors;
  }
}

export type IFieldErrors = { _errors: string[]; } | { [key: string]: IFieldErrors; };
export type IFormErrors = {
  message: string;
  errors: IFieldErrors;
};


export const ERRORS_EMPTY = { _errors: [] };

export const ErrorManager = (errors: IFieldErrors) => {
  /**
   * Error Handling Functionality /w Validation
   */
  const getError = (field: string): string | undefined => {
    const fieldError = getFieldError(field);
    const messages = fieldError._errors as string[];
    return messages[0] || undefined;
  };

  const getErrorMessages = (field: string): string[] => {
    const fieldError = getFieldError(field);
    return fieldError._errors as string[];
  };


  const getMessage = (): string | undefined => {
    const messages = errors._errors as string[];
    return messages[0] || undefined;
  };

  const getFieldError = (field: string): IFieldErrors => {
    const empty = { _errors: [] };
    const error = errors ? get(errors, field, empty) : empty;
    if ('_errors' in error && Array.isArray(error._errors)) {
      return error;
    }
    return empty;
  };

  const hasError = (field: string): boolean => {
    return getError(field) ? true : false;
  };


  return {
    getMessage,
    getErrorMessages,
    getError,
    getFieldError,
    hasError
  };
};